export const environment = {
  production: true,
  config: './assets/config/proleisw0sup.bmw.com.config.json'
};
